import React, { useState,useCallback,useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Map, {
  FullscreenControl,
  Popup,
  // FlyToInterpolator,
} from "react-map-gl";
import Style from "components/CityMap/CityMapBox.module.css";

// import { easeCubic } from "d3-ease";
import { extent } from "d3-array";
// import { useInterval } from "util/useInterval";
// import { getPerlData } from "service/GenericData";
import Markers from "components/CityMap/CityMarkers";
import MapLegend from "components/CityMap/mapLegend";

const CityMapBox = ({
  title,
  data,
  language='zh-Hans'
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  // setup map
  const [viewState, setViewState] = React.useState({
    latitude: 34, // decrease to move up
    longitude: 105, // increase to move left
    width: "100%",
    height: "600px",
    zoom: 3.3,
  });
  // const [viewport, setViewport] = React.useState(defaultViewport.current);

  // const [mapTitle, setMapTitle] = React.useState("");

  // Tooltip controls
  const [showPopup, setShowPopup] = React.useState(false);
  const [latFocus, setLatFocus] = React.useState(0);
  const [lngFocus, setLngFocus] = React.useState(0);
  const [offsetFocus, setOffsetFocus] = React.useState(0);
  const [tooltip, setTooltip] = React.useState("");
  const [minDomain, setMinDomain] = React.useState(-1);
  const [maxDomain, setMaxDomain] = React.useState(-1);
  const [zoomedIn, setZoomedIn] = React.useState(false)
  // Fullscreen controls
  const [fullScreen, setFullScreen] = React.useState(false);
  React.useEffect(() => {
    if (!fullScreen) {
      // setViewport(defaultViewport.current);
    }
  }, [fullScreen]);

  const mapRef = React.useRef();

  // const [colorRange, setColorRange]=useState([])
  const colorRange = ['#1f77b4',
    '#aec7e8',
    '#ff7f0e',
    '#ffbb78',
    '#2ca02c',
    '#98df8a',
    '#ef6f6a',
    '#ff9896',
    '#9467bd', '#c5b0d5', '#8c564b', '#c49c94', '#e377c2', '#f7b6d2', '#bcbd22', '#dbdb8d', '#17becf', '#9edae5', '#8175aa', '#6fb899',
    '#31a1b3', '#ccb22b', '#a39fc9', '#94d0c0', '#027b8e', '#9f8f12', '#7f7f7f', '#c7c7c7']
  
  function getSum(total, value){
    return total + value
  }
  const [lineageList, setLineageList]=React.useState([])
  React.useEffect(() => {

    // setMapTitle("Geographical Distribution of Lineages (China) ");
    if(data&&data.length>0){
      setLineageList(data[0].lineageList.map(item=>item.name))
    }
    const [lowerBound, upperBound] = extent(data.map((val) => val.lineageList.map(item=>item.value).reduce(getSum, 0)));
    setMinDomain(lowerBound);
    setMaxDomain(upperBound);

    // const initFocus = data.find((value) => value.collectionDate === upperBound);
    // const newViewport = {
    //   ...defaultViewport.current,
    //   latitude: parseFloat(
    //     defaultViewport.current.latitude
    //   ),
    //   longitude: parseFloat(
    //     defaultViewport.current.longitude
    //   ),
    //   transitionDuration: 1000,
    //   // transitionInterpolator: new FlyToInterpolator(),
    //   transitionEasing: easeCubic,
    // };

    // setViewport(newViewport);
  }, [data]);

  const [map, setMap] = useState()

  // Called only once map is rendered (async)
  const onRender = useCallback(() => {
    const mapElem = mapRef?.current
    if (!mapElem) return

    // Saves map reference to state
    setMap(mapElem)
  }, [])

  useEffect(() => {
    if (map && language) {
      map.setLanguage(language) // <= HERE IS THE KEY: This sets the language.
    }
  }, [map, language])

  const onMove = React.useCallback(({viewState}) => {
    if (viewState.zoom > 3.4) {
          setZoomedIn(true)
        } else {
          setZoomedIn(false)
        }
        setViewState(viewState);
    // const newCenter = [viewState.longitude, viewState.latitude];
    // // Only update the view state if the center is inside the geofence
    // if (turf.booleanPointInPolygon(newCenter, GEOFENCE)) {
    //   setViewState(newCenter);
    // }
  }, [])

  return isLoading ? (
    <div>
      <h2 className={Style.title}>{title}</h2>
      <div className={Style.loader} />
    </div>
  ) : (
    <Container>
      <Row className="justify-content-md-center">
        <Col xs={12}  >
          <h3 className={Style.title}>{title}</h3>
          <Map
            {...viewState}
            maxZoom={30}
            mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
            mapStyle="mapbox://styles/mapbox/light-v11"
            // onViewportChange={(newViewport) => {
            //   setViewport({ ...newViewport, width: "100%", height: "600px" });
            //   if (newViewport.zoom > 3.5) {
            //     setZoomedIn(true)
            //   } else {
            //     setZoomedIn(false)
            //   }
            // }}
            onMove={onMove}
            style={{width: "100%", height: 600}}
            ref={mapRef}
            onRender={onRender}
          >
            {/* <div
              style={{ position: "absolute", right: "25px" }}
              onClick={() => setFullScreen(!fullScreen)}
            > */}
              {/* <FullscreenControl container={document.querySelector("root")} /> */}
              <FullscreenControl />
            {/* </div> */}
            {zoomedIn ? (<Markers
              data={data}
              setShowPopup={setShowPopup}
              setLatFocus={setLatFocus}
              setLngFocus={setLngFocus}
              setOffsetFocus={setOffsetFocus}
              setTooltip={setTooltip}
              colorRange={colorRange}
              minCount={minDomain}
              maxCount={maxDomain}
              minRadius={18}
              maxRadius={25}
              zoomedIn={true}
            />):(<Markers
              data={data}
              setShowPopup={setShowPopup}
              setLatFocus={setLatFocus}
              setLngFocus={setLngFocus}
              setOffsetFocus={setOffsetFocus}
              setTooltip={setTooltip}
              colorRange={colorRange}
              minCount={minDomain}
              maxCount={maxDomain}
              minRadius={9}
              maxRadius={17}
              zoomedIn={false}
            />)}
            {showPopup ? (
              <Popup
                latitude={latFocus}
                longitude={lngFocus}
                offsetTop={offsetFocus}
                closeButton={false}
                anchor="bottom"
              >
                <div>{tooltip}</div>
              </Popup>
            ) : null}
          </Map>
        </Col>
        
      </Row>
      <Row  className="justify-content-md-center">
        <Col xs={12} >
          <MapLegend colorRange={colorRange} lineageList={lineageList}/>
        </Col>
      </Row>
    </Container>
  );
};

export default CityMapBox;
